import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface GiftVoucherModel extends BaseModel {
  variables?: { [key: string]: string } | GiftVoucherVariables;
}

export interface GiftVoucherVariables {
  GiftVoucherHeading: string;
  GiftVoucherText: string;
  GiftVoucherImage: string;
  GiftVoucherImageHref: string;
  GiftVoucherImageAlt: string;
  GiftVoucherCtaLink: string;
  GiftVoucherCtaText: string;
  GiftVoucherImageHrefSegmentRegex: string;
  GiftVoucherCtaLinkSegmentRegex: string;

}

export class GiftVoucherInitVariables implements GiftVoucherVariables {
  GiftVoucherHeading = '';
  GiftVoucherText = '';
  GiftVoucherImage = '';
  GiftVoucherImageHref = '';
  GiftVoucherImageAlt = '';
  GiftVoucherCtaLink = '';
  GiftVoucherCtaText = '';
  GiftVoucherImageHrefSegmentRegex = '';
  GiftVoucherCtaLinkSegmentRegex = '';
}

export class GiftVoucherInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new GiftVoucherInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
